import { SELECT_DEALER } from 'constants/ActionTypes';
import * as types from 'modules/leads/actionTypes';
import type { LeadsInterventionFilters, SetInterventionFiltersAction } from 'modules/leads/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: LeadsInterventionFilters = {
  sort: 'createdOn,desc',
  text: null,
};

const updateState = (state: LeadsInterventionFilters, { payload }: SetInterventionFiltersAction): LeadsInterventionFilters => ({
  ...state,
  ...payload,
});

const clearFilters = (): LeadsInterventionFilters => initialState;

export default createReducer<LeadsInterventionFilters>(initialState, {
  [types.SET_INTERVENTION_FILTERS]: updateState,
  [SELECT_DEALER]: clearFilters,
});
